import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "./Logo_Space.jpg"; 

const getCurrentDate = () => {
  const date = new Date();
  return date.toLocaleDateString("en-GB"); 
};

const addressIcon =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAACmElEQVR4nO3d227qQAyF4cVW3/+V2TetlI4CZBpPsmz/33ULjr08IA5CAgAAAAAAAAAAAAAAAAAAAAAAAJDP4+4CLvac+NsWval+kTMD/6Rkr0pelGIHPyrVs1IXo7WDH5XoXYmL0LWDH6Xu4b+7Cwhw5/Ad7v+U7AFwab5LHdOyHl/ODU/V04wngPPwJf/6fskWgCzNzVJnugAgWKYApNmqbynqzRKAFM3cYV93hgDYN/ED6/ozBAALuQfAensm2F7H190F3OH5fD2PxyPV6zinOV9t+Na8G/xoURDs+m1X0EZYAGYGPwoOgl2/XZ8DWAw/4v/Hm4u8sQiuAQgRNbzgEFgpG4DooVUNQdkA4BjHAJxetVXbGnS7VkeJYwBwoXIBWP1YXe25QLkAYA4BaI4ANEcAmiMAzRGA5soFYPX7+dU+L1AuAJjjGIDTK7ZqS4Nu1+oIcQwALlQ2ANGnQLXH/h9lAyDFDa3q8CXfAIR1/Ozwqn8m0K6gDT4VfAG7ggZL3nu96XsBlr22LGqj0pvvlr12fQ7ww7Jpf2B7He4BwGIZAmC7PQdZ158hAJJ5E9+wrztLAKQEzRykqDdTALBAtgCk2CrlqTNdACT/5rrX90uqYnc4vVCUspcZT4Atl6a71DEtewCk+5t/9/2fkrr4HfxiyKQSF7GD3ww6qMJDwJ5VQyo1fKluAKT4YZUbvlQ7ADiAADRXPQBRx3bJ41+qHwB80CEAZ7e37PZLPQKAN7oE4K9bXHr7pT4BwAudAjC7zeW3X+oVAOzoFoCjW91i+6V+AcCgYwA+bXeb7Zd6BgAbXQPwastbbb/UNwD41jkA47a3236pdwAASV5fLrkcJwAAAAAAAAAAAAAAAAAAAAAAAACQ0X/ycVCg4tpzvgAAAABJRU5ErkJggg==";

const phoneIcon =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAACK0lEQVR4nO3dW27bMBRFUbro/KfsfhQpWiNB4xfvkc5aAwjIyy1KQD68FgAAAAAAAABwNpfpBXzTdXoBT4iecfLijnzoX4mbd9yC1jkP/lbM3H9ML+BGw+GvFbTPlBJjBjJg9AwSboDmw19reP8JATBoOoD2p//D2Bwm3z8Pb/p6ze3mcnlqpNvP41ABJB/8rQdDqAngrpM80sHfeiCErWcy/Q3wX0c+/LXy1x99A7xieE++kyfWcfobYNvhJ7ljP1s3Hv8K4L0iAzjb0/8hcV+RAbBPXACJT8krpe0vLgD2+jm9gHdLe+LSuAHKCaCcAMoJoJwAygmgnADKCaCcAMoJoJwAygmgnADKCaCcAMoJoJwAygmgnADKCaCcAMoJoJwAygmgnADKCaCcAMoJoJwAygmgnADKCaCcAMoJoJwAygmgnADKCaCcAMoJoJwAygmgnADKCaCcAMoJoJwAygmgnADKCaCcAMoJoFxcAK/4rd9kafuLC4C9IgNIe0peJXFfkQGwT2wAiU/LM1L3ExvAWrlDu1fyPqIDWCt7eN+Rvv6J1T38Y75H+h3gJw9+27kcKoA/fyA4hBc98QIot+1c4r8BeC8BlJsIIPuzeN7W+bgBygmg3FQAXgOf2z4XN0C5yQDcAv8amcf0DSCC38bmMB0AwxICaL8FRvefNvym/xNEzD7hBvhbxFA2iNlnzEI+ccbbIG7ecQv6wpFjOMqMAQAAAAAAADiPX0YLRr6U4TKsAAAAAElFTkSuQmCC";

const bankIcon =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAACEUlEQVR4nO3cwVJbMQyGUdP3f2dYdVGmpYRrW7L/czbs4Eb6omGRyRgAAAAAAAB3e69+gEq/qh+g2Punn3Heqh+gyFcLj5pJ4gX437s96hqkBfDd5cZEkHLuniz06hklXICn7+arr8HtAcxa3rUR3HreVi7sqpndeAFWv1uvuga3BbBrOddEcMs5q1zI0TO84QJUvxur//4jpwfQZfhdnuNlp56vzgM/aqYnXoDOyx+j//P94bQAThnuKc95zLk6ZqB/0XrGJ1yAk5c/RvPn7x5A6+G9oO3r6Hqe2g5sglYz73gBbl7+GM1eX7cAWg1noTavs8s5ajOQAqU76HABkpc/RvHrrw4gffm/lc2h6vxY/L9t3UnFBbD8r22dz+4ALP97ts1p17mx+J9buqMdF8Dyn1k6v9UBWP4cy+a46rxY/DpTd7biAlj+WlPnOzsAy99j2pxnnROLr/NohzMugOXXMn8AAF5T+XGkn/z3+srznv77t6j+RBDFBBBOAOEEEE4A4QQQTgDhBBBOAOEEEE4A4QQQTgDhBBBOAOEEEE4A4QQQTgDhBBBOAOEEEE4A4QQQTgDhBBBOAOEEEE4A4QQQTgDhBBBOAOEEEE4A4QQQTgDhBBBOAOEEEE4A4XZ8c6Xvs39u2Z5cgHACCCeAcAIIJ4BwAggngHACCCeAcAIIJ4BwAgAAAAAAAAAAAIA7fAD0g0F45n6DBQAAAABJRU5ErkJggg==";


function cleanObject(obj) {
  const newObj = {};
  for (let key in obj) {
    let cleanKey = key.trim();
    let value = obj[key];

    if (typeof value === "object" && value !== null) {
      newObj[cleanKey] = cleanObject(value); 
    } else if (typeof value === "string") {
      let cleanVal = value.trim();

      if (cleanVal === "-" || cleanVal === "") {
        cleanVal = "";
      }

      cleanVal = cleanVal.replace(/,/g, "");

      newObj[cleanKey] = cleanVal;
    } else {
      newObj[cleanKey] = value;
    }
  }
  return newObj;
}

const generatePDFBase64 = async (records, extraField, serNo) => {
  const record = cleanObject(records);
  const doc = new jsPDF("p", "mm", "a4");
  const margin = 15;
  const pageWidth = doc.internal.pageSize.getWidth();
  let y = margin;

  if (logo) {
    doc.addImage(logo, "JPEG", margin, y, 60, 23.2);
  }
  y += 30;

  doc.setDrawColor(200);
  doc.setLineWidth(0.2);
  doc.roundedRect(margin, y, pageWidth - 2 * margin, 10, 3, 3);
  doc.setFontSize(13);
  doc.setFont("helvetica", "bold");
  doc.text("Pro Forma Invoice", margin + 5, y + 7, { align: "left" });
  y += 20;

  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");

  const invoiceStr = `${extraField["row1"][""]}/${extraField["row2"][""]}/${serNo}`;

  const detailsLeft = [
    ["Name :", `${record["Salutation"] || ""} ${record["Name"] || ""}`],
    ["Proforma No. :", invoiceStr],
  ];
  const detailsRight = [
    ["Pan No. :", record["Pan Card"] || ""],
    ["Date :", getCurrentDate()],
    ["Address :", record["Location"] || ""],
  ];

  detailsLeft.forEach((d, i) => {
    doc.text(d[0], margin, y + i * 7);
    doc.text(d[1], margin + 40, y + i * 7);
  });
  detailsRight.forEach((d, i) => {
    doc.text(d[0], pageWidth / 2 + 10, y + i * 7);
    doc.text(d[1], pageWidth / 2 + 40, y + i * 7);
  });

  y += 25;

  const landRows = (record["Land Package Details"] || "")
    .split("\n")
    .filter((row) => row.trim() !== "")
    .map((row) => ["", row, "", "INR", "-"]);

  const body = [
    ["1", "Domestic Flight", "", "INR", record["Domestic Flight"] || ""],
    ["2", "International Flight", "", "INR", record["International Flight"] || ""],
    ["3", "Visa", "", "INR", record["Visa"] || ""],
    ["4", "Registration", "", "INR", record["Registration"] || ""],
    ["5", "Insurance", "", "INR", record["Insurance"] || ""],
    ["6", "Land Package", "", "INR", record["Land Package"] || ""],
    ...landRows,
    ["7", "Service Charge", "", "INR", record["Service Charge"] || ""],
    ["", "Sub Total", "", "INR", record["Total"] || ""],
    ["", "GST", "5%", "INR", record["GST-5%"] || ""],
    ["", "TCS", "5%", "INR", record["TCS-5%"] || ""],
    ["", "Grand Total", "", "INR", record["Grand Total"] || ""],
    ["", "Received Amount", "", "INR", record["Total Received"] || ""],
    ["", "Balance", "", "INR", record["Balance"] || ""],
  ];

  autoTable(doc, {
    startY: y,
    head: [["S.No.", "Particulars", "Details", "Currency", "Amount (INR)"]],
    body,
    theme: "striped",
    styles: { fontSize: 10, valign: "middle", cellPadding: 3 },
    headStyles: {
      fillColor: [21, 101, 51],
      textColor: 255,
      halign: "center",
      fontStyle: "bold",
    },
    columnStyles: {
      0: { cellWidth: 15, halign: "center" },
      1: { cellWidth: 60 },
      2: { cellWidth: 30 },
      3: { cellWidth: 25, halign: "center" },
      4: { cellWidth: 40, halign: "right" },
    },
    didParseCell: function (data) {
      if (data.row.raw && data.row.raw[1] === "Balance") {
        data.cell.styles.fillColor = [21, 101, 51];
        data.cell.styles.textColor = [255, 255, 255];
        data.cell.styles.fontStyle = "bold";
      }
    },
  });

  let tableY = doc.lastAutoTable.finalY + 15;
  const colWidth = (pageWidth - 2 * margin) / 2;

  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.addImage(bankIcon, "PNG", margin, tableY - 4, 5, 5);
  doc.text("Bank Details", margin + 8, tableY);

  doc.addImage(addressIcon, "PNG", margin + colWidth + 10, tableY - 4, 5, 5);
  doc.text("Registered Office", margin + colWidth + 18, tableY);

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  tableY += 6;
  doc.text("Beneficiary Name: Soham Experiences Pvt Ltd", margin, tableY);
  doc.text(
    "Soham Experiences Pvt. Ltd.- 6041, ATS Pristine,",
    margin + colWidth + 18,
    tableY
  );

  tableY += 5;
  doc.text("Account Number: 99999999848240", margin, tableY);
  doc.text("Sector 150, Noida 201301", margin + colWidth + 18, tableY);

  tableY += 5;
  doc.text("Bank & Address: HDFC Bank Ltd, Mulund West, Mumbai", margin, tableY);

  doc.addImage(phoneIcon, "PNG", margin + colWidth + 10, tableY - 2, 5, 5);
  doc.text("+91 7982113313", margin + colWidth + 16, tableY+1.5);

  tableY += 5;
    const boxX = margin;
    const boxWidth = (pageWidth - 2 * margin) / 2 - 5; 
    const boxHeight = 12;

    doc.setDrawColor(150); 
    doc.roundedRect(boxX, tableY, boxWidth, boxHeight, 2, 2);

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("IFSC: HDFC0003354", boxX + 3, tableY + 5);
    doc.text("Account Type: Current", boxX + 3, tableY + 10);

    tableY += boxHeight + 5;

    doc.addPage();  
    tableY = margin;  
    
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("Note", margin, tableY);
    
    tableY += 8;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);

  const notes = [
    "TCS - 5% or 20% will be based on remittances made by the traveler in a financial year.",
    "Purchase of Overseas Tour packages up to 7,00,000 in a financial year will attract 5% TCS.",
    "Purchase of Overseas Tour packages above 7,00,000 in a financial year will attract 20% TCS.",
    "TCS is an abbreviation for Tax Collected at Source. Provisions of TCS are mandatory.",
    "To claim back TCS, the amount collected will reflect in the FORM 26AS.",
  ];

  notes.forEach((note) => {
    if (tableY > 280) {
      doc.addPage();
      tableY = margin;
    }
    doc.setTextColor(21, 101, 51);
    doc.text("‣", margin, tableY);
    doc.setTextColor(0, 0, 0);
    doc.text(note, margin + 5, tableY, { maxWidth: pageWidth - margin * 2 });
    tableY += 6;
  });

  return doc.output("datauristring").split(",")[1];
};

export default generatePDFBase64;
